import { useEffect } from 'react';


const useDocumentTitle = (title) => {
  useEffect(() => {
    const prevTitle = document.title;
    const domain = 'EroPlay.ai';
        
    document.title = title ? `${title} | ${domain}` : `${domain} — AI-powered companions`;
    
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};

export default useDocumentTitle; 